import { api, ReactQueryOptions, RouterInputs, RouterOutputs } from '@api';
import { UseTRPCInfiniteQueryOptions } from '@trpc/react-query/shared';
import { TRPCClientErrorLike } from '@trpc/client';
type inputType = RouterInputs['StoreManager']['getList'];
type queryOptionsType = ReactQueryOptions['StoreManager']['getList'];
type outputType = RouterOutputs['StoreManager']['getList'];
type optionsType = UseTRPCInfiniteQueryOptions<'StoreManager.getList', inputType, outputType, TRPCClientErrorLike<any>>;
export const useGetStoreInfiniteList = (input: inputType, options?: optionsType) => api.StoreManager.getList.useInfiniteQuery(input, {
  queryKey: ['StoreManager.getList', input],
  getNextPageParam: firstPage => firstPage.nextCursor,
  refetchOnWindowFocus: false,
  initialCursor: undefined,
  staleTime: 15 * 60 * 1000,
  // 15 mins
  ...options
});
export const useGetStoreList = (input: inputType, options?: queryOptionsType) => api.StoreManager.getList.useQuery(input, {
  ...options,
  queryKey: ['StoreManager.getList', input],
  staleTime: 15 * 60 * 1000 // 15 mins
});